//倒计时
function show_djs_time(zdy_time){ 
    var time_start = new Date().getTime(); //设定当前时间
    var time_end =  new Date(zdy_time).getTime(); //设定目标时间 转换为毫秒
    // 计算时间差 
    var time_distance = time_end - time_start;     // 天
    var int_day = Math.floor(time_distance/86400000) 
    time_distance -= int_day * 86400000;     // 时
    var int_hour = Math.floor(time_distance/3600000) 
    time_distance -= int_hour * 3600000;     // 分
    var int_minute = Math.floor(time_distance/60000) 
    time_distance -= int_minute * 60000;     // 秒 
    var int_second = Math.floor(time_distance/1000)     // 时分秒为单数时、前面加零 
    if(int_day < 10){ 
        int_day = "0" + int_day; 
    } 
    if(int_hour < 10){ 
        int_hour = "0" + int_hour; 
    } 
    if(int_minute < 10){ 
        int_minute = "0" + int_minute; 
    } 
    if(int_second < 10){
        int_second = "0" + int_second; 
    } 
    // 显示时间		
	jQuery('#djs_day_show').html(int_day);
	jQuery('#djs_hour_show').html(int_hour);
	jQuery('#djs_minute_show').html(int_minute);
	jQuery('#djs_second_show').html(int_second);
    // 设置定时器  每1秒执行一次变量函数show_time  用于刷新计时器
    setTimeout("show_djs_time('"+zdy_time+"')",1000); 	
	 //判断目前时间如果小于当前时间则执行以下命令
	if(time_end<time_start ){
		jQuery(".djsn_time").css("display","none"); 
		jQuery(".djsd_time").css("display","block"); 
	}
}